import React from "react";
import "./Footer.scss"
import fb from "../../image/fb.svg"
import twitter from "../../image/twitter.svg"
import linkedIn from "../../image/linkedin.svg"
import insta from "../../image/insta.svg"
import logo from "../../image/logo-ic.png"
import apple from "../../image/apple.svg"
import playstore from "../../image/playstore.svg"





const Footer = () => {
    const footerContet = [
        {
            "header": "Company",
            "content": ["About Us", "Careers", "Press",
                "Contact"
            ]
        }, {
            "header": "Support",
            "content": ["Help Center", "Privacy Policy", "Terms of Service",
                "Security"
            ]
        },
    ]
    return (
        <div className="RewardsTickFooter">
            <div className="RewardsTickFooter-top">
                <div className="RewardsTickFooter-top-grid-item">
                    <div className="RewardsTickFooter-header-logo">
                        <img alt="" src={logo} />
                        RewardsTick
                    </div>
                    <div className="RewardsTickFooter-contnt">
                        Transform your shopping experience with instant rewards and cashback on every purchase.   </div>
                </div>
                {footerContet.map((content, key) => {
                    return (
                        <div className="RewardsTickFooter-top-grid-item" key={key}>
                            <div className="RewardsTickFooter-header">
                                {content?.header}
                            </div>
                            {content.content.map((ctn, idx) => {
                                return (<div className="RewardsTickFooter-contnt" key={idx}>
                                    {ctn} </div>)
                            })}

                        </div>
                    )
                })}
                <div className="RewardsTickFooter-top-grid-item">
                    <div className="RewardsTickFooter-header">
                        Download
                    </div>
                    <div className="RewardsTickFooter-install">
                        <img alt="" src={apple} /> App Store
                    </div>
                    <div className="RewardsTickFooter-install">
                        <img alt="" src={playstore} />    Google Play
                    </div>
                </div>
            </div>
            <div className="RewardsTickFooter-bottom">
                <div className="RewardsTickFooter-bottom-left">
                    © 2024 RewardsTick. All rights reserved.
                </div>
                <div className="RewardsTickFooter-bottom-right">
                    <div className="RewardsTickFooter-bottom-right-cards">
                        <div className="footer-btm-card-cont">
                            <img alt="" src={fb} />

                        </div>
                        <div className="footer-btm-card-cont">

                            <img alt="" src={twitter} />
                        </div>
                        <div className="footer-btm-card-cont">

                            <img alt="" src={linkedIn} />
                        </div>
                        <div className="footer-btm-card-cont">
                            <img alt="" src={insta} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer